import Vue from 'vue'
import Vuetify from 'vuetify'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VueMoment from 'vue-moment'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import FullscreenSpinner from './components/commons/FullscreenSpinner.vue'
import VueSweetAlert from 'vue-sweetalert'

import App from './App.vue'
import router from './router'
import store from './store'
import auth from './auth'


Vue.use(Vuetify, {
  theme: {
    primary: '#0148a0', // Cor do texto da logo da UNIFEBE, base -> $blue.darken-2
    accent: '#448aff', //$blue.accent-2,
    secondary: '#616161', //$grey.darken-3,
    info: '#008cd3', // base -> $blue.base
    warning: '#ff8f00', // $amber.darken-3
    error: '#f44336', // $red.base
    success: '#4caf50' //$green.base
  }
})
Vue.use(VueResource)
const veevalidate_locale = require('./locale/vee-validate-pt-br')
Vue.use(VeeValidate, { locale: 'pt-br', dictionary: { 'pt-br': veevalidate_locale.default }, errorBagName: 'vErrors' })
Vue.use(VueMoment)
Vue.use(VueSweetAlert)

// Vue.http.options.root = "https://bancas.unifebe.edu.br/ws-dev/"
Vue.http.options.root = process.env.API_URL
Vue.http.options.emulateJSON = true
//Vue.http.options.emulateHTTP = true

// Check the users auth status when the app starts
auth.checkAuth()
Vue.http.headers.common['Authorization'] = auth.getAuthHeader()

Vue.component('pulse-loader', PulseLoader)
Vue.component('fullscreen-spinner', FullscreenSpinner)

// Maintain a list of ongoing request to show fullscreen loading spinner
Vue.http.interceptors.push(function (request, next) {
  // Don't show fullscreen loading spinner in these situations
  if (request.url == 'students') {
    request.hideFullscreenLoadingSpinner = true
  }
  if (request.url == 'evaluations') {
    request.hideFullscreenLoadingSpinner = true
  } 
  if (request.url == 'fillEvaluationCriterion') {
    request.hideFullscreenLoadingSpinner = true
  }    
  if (request.url == 'calcEvaluationScore') {
    request.hideFullscreenLoadingSpinner = true
  }      
  this.$store.commit('addHttpRequest', request)
  next(function (response) {
    this.$store.commit('removeHttpRequest', request)
  })
})

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})

import './misc'



// WEBPACK FOOTER //
// ./src/main.js